import { useState } from 'react';

/**
 * Retrieves the current token stored in sessionStorage.
 * @returns {string|null} The token if it exists, otherwise null.
 */
const getStoredToken = () => {
    const token = sessionStorage.getItem( 'token' );
    return token ?? null;
};

/**
 * Custom hook for managing authentication token using sessionStorage.
 * Provides token state and a setter function to persist it.
 *
 * @returns {{
 *   token: string | null,
 *   setToken: (userToken: string) => void
 * }}
 */
const useToken = () => {
    const [token, setToken] = useState(getStoredToken());

    /**
     * Saves the token to sessionStorage and updates state.
     * @param {string} userToken - Token to store and set in state.
     */
    const saveToken = ( userToken ) => {
        if ( typeof userToken !== 'string' ) {
            console.warn( 'Attempted to save a non-string token:', userToken );
            return;
        }

        sessionStorage.setItem( 'token', userToken );
        setToken( userToken );
    };

    return {
        token,
        setToken: saveToken,
    };
}

export default useToken;